import { FormControl, FormGroup } from '@angular/forms';
import { AgedPackageStatus } from 'src/app/core/models/reports/reports.model';
import { Options } from '../../../shared/report-format/report-format.constants';

export const CONSTS = {
  HEADER: $localize`Aged Package Status`,
  ROUTE_LABEL: $localize`Route`,
};

export const REPORT_FILE_NAME = 'Aged-Package-Status-Report';

export const PDF_REPORT = {
  NAME: 'Aged Package Report',
  HEADER: {
    LOOP: 'Loop:',
    LOCATION: 'Location:',
    PRINTED: 'Printed:',
  },
  COLUMNS: [
    'Date'.toUpperCase(),
    'Trackno'.toUpperCase(),
    'Code'.toUpperCase(),
    'Customer'.toUpperCase(),
    'Street'.toUpperCase(),
    'City'.toUpperCase(),
    'Loop'.toUpperCase(),
    'Drop Off Date'.toUpperCase(),
  ],
  DATA_FIELDS: [
    'date',
    'trackNo',
    'code',
    'customer',
    'street',
    'city',
    'loop',
    'dropOffDate',
  ] as (keyof AgedPackageStatus)[],
};

type AgedPackageStatusFormField = {
  routes: FormControl<string>;
  reportFormat: FormControl<Options>;
};

export type AgedPackageStatusFormGroup =
  FormGroup<AgedPackageStatusFormField> | null;
